export default {
  WOKAP_IA: {
    WIZARD: {
      TITLE: 'wokapIA',
      NAVBAR_TITLE: 'Find your candidate',
      SUBTITLE: 'wokapIA is the <b>wokap network</b> where you can find your ideal candidate and invite them to apply to your job offer. Follow the steps below.',
      ARIA_LABEL: 'wokapIA wizard steps',
      STEPS: {
        OCCUPATION: 'Profile',
        FILTERS: 'Filter',
        SAVE: 'Confirm',
        OFFERS: 'Create offer',
      },
      STEP_DESCRIPTIONS: {
        OCCUPATION: {
          TITLE: 'Occupation / Profession:',
          DESCRIPTION: 'Select the occupations/professions of the candidates that best match your job opening.',
        },
        FILTERS: {
          TITLE: 'Filters',
          DESCRIPTION: 'Apply filters to define the characteristics of the candidates you are looking for.',
        },
        SAVE: {
          TITLE: 'Confirm',
          DESCRIPTION: 'Assign a title to the folder and confirm the candidates you would like to invite.',
        },
        OFFERS: {
          TITLE: 'Create the Job Posting',
          DESCRIPTION: 'Create the job posting so we can send invitations to the candidates you selected. Once candidates apply, you will be able to manage them within the job posting.\nIn addition, any wokap user interested in your vacancy will also be able to apply. Use the filters to easily distinguish between the candidates you invited and those who applied on their own.\nOnce created and published, the job posting will appear in your “Job Postings Panel”.',
        },
      },
    },
    OCCUPATION: {
      TITLE: 'Select the profiles you are looking for.',
      LABEL: 'Occupation / Profession',
      DESCRIPTION: 'Select the Occupation / Profession of the candidates that best fit your vacancy.',
      NETWORK_BADGE: 'wokap network',
      SELECT_OCCUPATION_ERROR: 'Select at least one occupation to continue.',
      SEARCH_PLACEHOLDER: 'Search Occupation / Profession',
    },
    FILTERS: {
      OCCUPATIONS_SELECTED_LABEL: 'Selected Occupation(s) / Profession(s):',
      OCCUPATION_LABEL: 'Occupation / Profession',
      OCCUPATIONS_COUNT_LABEL: 'occupations',
      FORMATION_LABEL: 'Education / Training',
      COUNTRY_LABEL: 'Country',
      CITY_LABEL: 'City',
      CITY_LOCKED: 'Select a country first',
      LANGUAGE_LABEL: 'Languages',
      LANGUAGE_LEVEL_LABEL: 'Minimum level',
      LEVEL_BASIC: 'Basic',
      LEVEL_INTERMEDIATE: 'Intermediate',
      LEVEL_ADVANCED: 'Advanced',
      LEVEL_NATIVE: 'Native',
      HARD_SKILLS_LABEL: 'Hard skills',
      SOFT_SKILLS_LABEL: 'Soft skills',
      OTHER_LABEL: 'Other competencies',
      CLEAR_FILTERS: 'Clear filters',
      SEARCH_IN_FILTER: 'Search...',
      SEE_MORE: 'See more',
      SEE_LESS: 'See less',
      FILTERS_TITLE: 'Filters',
      CANDIDATES_TITLE: 'Candidates',
      RESULTS_COUNT: 'candidates',
      NO_RESULTS_TITLE: 'No candidates with those filters',
      NO_RESULTS_SUB: 'Try adjusting some filters.',
      SELECTION_LABEL: 'candidates selected',
      SELECT_CANDIDATE_ERROR: 'Select at least one candidate to continue.',
      SAVE_TO_OFFER: 'Save to offer →',
      BACK_BTN: 'Back',
      NEXT_BTN: 'Continue',
      PREV_BTN: 'Back',
    },
    SAVE_OFFER: {
      TITLE: 'Save to offer',
      SUBTITLE: 'Archive selected candidates.\nThen create the offer to invite them.',
      OFFER_NAME_LABEL: 'Folder name',
      OFFER_NAME_PLACEHOLDER: 'E.g.: Architect residential project',
      CANDIDATES_LABEL: 'Selected candidates',
      CANDIDATES_TOOLTIP: 'Once you create the offer, these candidates will receive an invitation to apply for your vacancy',
      CANCEL: 'Cancel',
      SAVE: 'Save offer',
      NO_CANDIDATES_TOOLTIP: 'You cannot proceed without selected candidates',
      ERROR_TITLE_REQUIRED: 'Enter the folder name.',
      ERROR_CANDIDATES_REQUIRED: 'Go back to the previous screen to add candidates to your offer.',
    },
    OFFER_DECISION: {
      TITLE: 'Do you want to create the offer now?',
      SUBTITLE: 'Once created and published, we will send an invitation to the selected candidates.',
      OFFER_NAME_LABEL: 'Folder name:',
      CANDIDATES_TO_INVITE: 'candidates to invite',
      CREATE_NOW_TITLE: 'Create offer now',
      CREATE_NOW_DESC: 'Complete the offer, publish it, and automatically invite your selection.',
      SAVE_LATER_TITLE: 'Save for later',
      SAVE_LATER_DESC: 'It will appear under "Offers to create" until you decide to continue.',
      BACK_BTN: 'Back',
    },
    OFFER_PANEL: {
      SECTION_TITLE: 'Offers to create',
      EMPTY: 'No pending offers to create.',
      TABLE: {
        TITLE: 'Title / Position',
        CANDIDATES: 'Candidates to invite',
        CANDIDATES_LABEL: 'candidates',
        DATE: 'Date',
        DATE_TOOLTIP: 'Date the offer was created',
        CANDIDATES_TOOLTIP: 'Once you create the offer, these candidates will receive an invitation to apply for your vacancy',
        STATUS: 'Status',
        ACTIONS: 'Actions',
      },
      BADGE: {
        PENDING: 'Offer pending creation',
        LINKED: 'Linked',
      },
      ACTION: {
        VIEW: 'Create offer',
        CREATE_OFFER: 'Create offer',
        DELETE: 'Delete',
        DELETE_CONFIRM_HEADER: 'Delete offer in creation',
        DELETE_CONFIRM_MSG: 'Are you sure you want to delete this offer in creation?',
        DELETE_CONFIRM_ACCEPT: 'Delete',
        DELETE_CONFIRM_REJECT: 'Cancel',
      },
      FINISH_BTN: 'Finish',
    },
    INVITE: {
      NO_OFFER: 'No offer created',
      NOTICE_TITLE: 'Before inviting, create the offer',
      NOTICE_SUB: 'Your candidates need to see what the position is about before deciding to apply. Create the offer first and then you can send them the invitation.',
      CREATE_OFFER_BTN: 'Create offer now',
      CANDIDATES_LABEL: 'Archived candidates',
      CANDIDATE_STATUS: 'Invitation pending',
      INVITE_ACTION: 'Invite',
      BACK_BTN: 'Back',
      NAV_NOTE: 'Create the offer to invite.',
    },
    LEAVE_MODAL: {
      TITLE: 'Unsaved changes',
      MESSAGE: 'You have unsaved changes, are you sure you want to leave?',
      STAY: 'Stay',
      LEAVE: 'Leave without saving',
    },
  },
};
